import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/features/auth/AuthProvider";
import { ThemeModeProvider } from "@/theme/ThemeModeProvider";
import { AutoTranslate } from "@/components/i18n/AutoTranslate";
import { GlobalRequestLoader } from "@/components/loading/GlobalRequestLoader";
import { UpdatePrompt } from "@/components/pwa/UpdatePrompt";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});

type AppProvidersProps = {
  children: React.ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeModeProvider>
          {children}
          <AutoTranslate />
          <GlobalRequestLoader />
          <UpdatePrompt />
        </ThemeModeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
